// @ts-strict-ignore
import { FcPermissionCode, Permission, User, UserPermissions } from '@fc-core';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployee from './employee.selectors';
import { getCurrentEmployee } from './employee.selectors';
import * as fromUser from '../reducers/current-user.reducer';

function hasPermission(
  perms: Permission[],
  codename: keyof UserPermissions,
): boolean {
  return perms.filter((obj) => obj.fullCodename === codename).length > 0;
}
export const getCurrentUserState =
  createFeatureSelector<fromUser.State>('currentUser');
export const getCurrentUserLoading = createSelector(
  getCurrentUserState,
  fromUser.getCurrentUserLoading,
);
export const getPermissionsLoading = createSelector(
  getCurrentUserLoading,
  fromEmployee.getLoadings,
  (currentUserLoading: boolean, employeeLoading: boolean): boolean => {
    return currentUserLoading || employeeLoading;
  },
);

export const getCurrentUser = createSelector(
  getCurrentUserState,
  fromUser.getCurrentUser,
);

export const getCurrentUserLegacyPermissions = createSelector(
  getCurrentUser,
  (user: User): UserPermissions => {
    const permissions = {
      accounting_customer_can_switch_customer_view: false,
    };
    if (user) {
      permissions.accounting_customer_can_switch_customer_view = hasPermission(
        user.permissions,
        'accounting_customer_can_switch_customer_view',
      );
    }

    return permissions;
  },
);

export const currentUserHasLegacyPermission = (
  codename: keyof UserPermissions,
) => {
  return createSelector(
    getCurrentUserLegacyPermissions,
    (permission: UserPermissions): boolean => {
      return permission[codename];
    },
  );
};

export const getCurrentEmployeePermissions = createSelector(
  getCurrentEmployee,
  (employee) => employee?.permissions,
);

export const currentEmployeeHasPermission = (codename: FcPermissionCode) => {
  return createSelector(
    getCurrentEmployeePermissions,
    (permissions: Permission[]): boolean =>
      permissions
        ?.map((permission) => permission?.codename)
        ?.includes(codename),
  );
};
